import React from 'react';
import { NavBar } from './navBar.js';

const AppLayout = ({ children }) => {
    return (
        <div>
            <NavBar />
            <div className="content">{children}</div>
        </div>
    );
};

export { AppLayout };